(function () {
  "use strict";

  if (window.ExoticCartKitController) return;

  var config = window.ExoticFreeGiftConfig || {};
  var triggerTag = normalize(config.triggerTag || "exotic-collection");
  var collectionHandles = (config.collectionHandles || ["exotic-collection"]).map(normalize).filter(Boolean);
  var configuredHandles = (config.qualifyingProductHandles || []).map(normalize).filter(Boolean);
  var productTagCache = new Map();
  var collectionCache = new Map();
  var syncTimer = null;
  var pendingCart = null;
  var isSyncing = false;
  var needsAnotherSync = false;

  if (!config.enabled) return;

  function normalize(value) {
    return String(value || "").trim().toLowerCase();
  }

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root + String(path || "").replace(/^\//, "");
  }

  function fetchJson(path, options) {
    return fetch(cartUrl(path), Object.assign({
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      cache: "no-store"
    }, options || {})).then(function (response) {
      if (!response.ok) throw new Error("Anniversary cart request failed: " + path);
      return response.json();
    });
  }

  function fetchCart() {
    return fetchJson("cart.js");
  }

  function isFullCart(cart) {
    return !!(cart && Array.isArray(cart.items) && typeof cart.item_count === "number");
  }

  function itemHasTriggerTag(item) {
    var tags = item && (item.tags || item.product_tags || item.productTags);

    if (Array.isArray(tags)) {
      return tags.some(function (tag) { return normalize(tag) === triggerTag; });
    }

    if (typeof tags === "string") {
      return tags.split(",").some(function (tag) { return normalize(tag) === triggerTag; });
    }

    return false;
  }

  function itemUrlHasCollection(item) {
    var url = normalize(item && item.url);
    return collectionHandles.some(function (handle) {
      return handle && url.indexOf("/collections/" + handle + "/") !== -1;
    });
  }

  function fetchProductTags(handle) {
    handle = normalize(handle);
    if (!handle) return Promise.resolve([]);
    if (productTagCache.has(handle)) return productTagCache.get(handle);

    var request = fetchJson("products/" + encodeURIComponent(handle) + ".js")
      .then(function (product) {
        var tags = product.tags || [];
        if (typeof tags === "string") return tags.split(",").map(normalize);
        if (Array.isArray(tags)) return tags.map(normalize);
        return [];
      })
      .catch(function () { return []; });

    productTagCache.set(handle, request);
    return request;
  }

  function fetchProductInCollection(productHandle, collectionHandle) {
    productHandle = normalize(productHandle);
    collectionHandle = normalize(collectionHandle);

    if (!productHandle || !collectionHandle) return Promise.resolve(false);

    var key = collectionHandle + "/" + productHandle;
    if (collectionCache.has(key)) return collectionCache.get(key);

    var request = fetchJson("collections/" + encodeURIComponent(collectionHandle) + "/products/" + encodeURIComponent(productHandle) + ".js")
      .then(function () { return true; })
      .catch(function () { return false; });

    collectionCache.set(key, request);
    return request;
  }

  function itemQualifies(item) {
    var handle = normalize(item && item.handle);
    var knownCollectionMatch = itemUrlHasCollection(item) || configuredHandles.indexOf(handle) !== -1;

    return fetchProductTags(item.handle).then(function (tags) {
      var hasTag = itemHasTriggerTag(item) || tags.indexOf(triggerTag) !== -1;

      if (!hasTag) return false;
      if (knownCollectionMatch) return true;

      return Promise.all(collectionHandles.map(function (handle) {
        return fetchProductInCollection(item.handle, handle);
      })).then(function (matches) {
        return matches.some(Boolean);
      });
    });
  }

  function qualifierQuantity(cart) {
    var items = cart.items || [];

    if (!items.length) return Promise.resolve(0);

    return Promise.all(items.map(itemQualifies)).then(function (matches) {
      return items.reduce(function (total, item, index) {
        return total + (matches[index] ? Number(item.quantity || 0) : 0);
      }, 0);
    });
  }

  function renderAnniversaryBars(isUnlocked, qualifyingQuantity) {
    Array.prototype.slice.call(document.querySelectorAll(".anniversary-bar-root")).forEach(function (bar) {
      var promoState = bar.querySelector(".anniversary-bar-state--promo");
      var unlockedState = bar.querySelector(".anniversary-bar-state--unlocked");

      bar.classList.toggle("anniversary-bar-promo", !isUnlocked);
      bar.classList.toggle("anniversary-bar-unlocked", isUnlocked);
      bar.setAttribute("data-initial-unlocked", isUnlocked ? "true" : "false");
      bar.setAttribute("data-qualifying-quantity", String(qualifyingQuantity || 0));

      if (promoState) promoState.hidden = isUnlocked;
      if (unlockedState) unlockedState.hidden = !isUnlocked;
    });
  }

  function renderCartPromos(isUnlocked) {
    Array.prototype.slice.call(document.querySelectorAll(".anniversary-cart-promo")).forEach(function (promo) {
      promo.classList.toggle("anniversary-cart-promo--unlocked", isUnlocked);
    });
  }

  function syncCart(cartFromEvent) {
    if (isSyncing) {
      if (isFullCart(cartFromEvent)) pendingCart = cartFromEvent;
      needsAnotherSync = true;
      return Promise.resolve();
    }

    isSyncing = true;

    var cartForSync = isFullCart(cartFromEvent) ? cartFromEvent : pendingCart;
    pendingCart = null;

    return (isFullCart(cartForSync) ? Promise.resolve(cartForSync) : fetchCart())
      .then(function (cart) {
        return qualifierQuantity(cart).then(function (targetQuantity) {
          var hasQualifier = targetQuantity > 0;
          renderAnniversaryBars(hasQualifier, targetQuantity);
          renderCartPromos(hasQualifier);
          document.dispatchEvent(new CustomEvent("exotic-cart-kit:updated", {
            bubbles: true,
            detail: { cart: cart, unlocked: hasQualifier, qualifyingQuantity: targetQuantity }
          }));
        });
      })
      .catch(function () {})
      .finally(function () {
        isSyncing = false;

        if (needsAnotherSync) {
          needsAnotherSync = false;
          scheduleSync(0, pendingCart);
        }
      });
  }

  function scheduleSync(delay, cart) {
    if (isFullCart(cart)) pendingCart = cart;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncCart(pendingCart);
    }, typeof delay === "number" ? delay : 180);
  }

  function patchFetch() {
    if (window._exoticFetchPatched) return;
    window._exoticFetchPatched = true;

    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = String(typeof input === "string" ? input : (input && input.url) || "");
      var isCartMutation = /\/(cart\/(change|add|update|clear))\.js/.test(url);
      var result = origFetch.apply(this, arguments);

      if (isCartMutation) {
        result.then(function (response) {
          if (!response.ok) return;
          response.clone().json().then(function (data) {
            scheduleSync(isFullCart(data) ? 60 : 120, isFullCart(data) ? data : null);
            window.setTimeout(function () { scheduleSync(0, null); }, 700);
          }).catch(function () {
            scheduleSync(200, null);
            window.setTimeout(function () { scheduleSync(0, null); }, 700);
          });
        }).catch(function () {});
      }

      return result;
    };
  }

  function bindEvents() {
    [
      "cart:change",
      "cart:refresh",
      "cart:updated",
      "ajaxCart:updated",
      "product:added",
      "variant:add",
      "line-item:change",
      "exotic-cart-kit:updated"
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (eventName === "exotic-cart-kit:updated") return;
        var cartData = event.detail && event.detail.cart;
        scheduleSync(0, cartData || null);
        window.setTimeout(function () { scheduleSync(0, null); }, 700);
      });
    });
  }

  function init() {
    patchFetch();
    bindEvents();
    scheduleSync(0, null);
  }

  window.ExoticCartKitController = {
    sync: syncCart
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}());
